import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.supported-application-types', {
        url: '/application/add',
        component: 'companySupportedApplicationTypes',
        resolve: {
            appCategories,
            appTypes,
            appPermissions,
        },
    });
}

/** @ngInject */
function appCategories(appCategories$) {
    return appCategories$.get()
}

/** @ngInject */
function appTypes(appTypes$) {
    return appTypes$.get()
}

/** @ngInject */
function appPermissions(AddNewApplicationResource,companyId) {
	return AddNewApplicationResource.getApplicationPermissionsInCompany(companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-application-types/supported-application-types.state.js